import { createStore } from './storeFactory';
import CaptainToolsAPI from '../../api/captain/tools';
import { throwErrorMessage } from 'dashboard/store/utils/api';

const toolsStore = createStore({
  name: 'captainTool',
  API: CaptainToolsAPI,
  getters: {
    getFilteredRecords: state => (filterIds = []) => {
      if (!filterIds.length) return state.records;
      return state.records.filter(record => filterIds.includes(record.id));
    },
  },
  actions: mutations => ({
    getTools: async ({ commit }) => {
      commit(mutations.SET_UI_FLAG, { fetchingList: true });
      try {
        const response = await CaptainToolsAPI.get();
        commit(mutations.SET, response.data);
        commit(mutations.SET_UI_FLAG, { fetchingList: false });
        return response.data;
      } catch (error) {
        commit(mutations.SET_UI_FLAG, { fetchingList: false });
        return throwErrorMessage(error);
      }
    },
    setEnabledExternalToolIds: ({ commit }, toolIds) => {
      commit('SET_ENABLED_EXTERNAL_TOOL_IDS', toolIds);
    },
  }),
});

// Add the enabledExternalToolIds state and its mutation
toolsStore.state.enabledExternalToolIds = [];
toolsStore.mutations.SET_ENABLED_EXTERNAL_TOOL_IDS = (state, toolIds) => {
  state.enabledExternalToolIds = toolIds;
};

export default toolsStore;
